export const GET_CONTENT = "GET_CONTENT";
export const GET_CONTENT_FINISH = "GET_CONTENT_FINISH";
export const GET_ALL_SELL_TRANSACTIONS = "GET_ALL_SELL_TRANSACTIONS";
export const GET_ALL_SELL_TRANSACTIONS_FINISH =
  "GET_ALL_SELL_TRANSACTIONS_FINISH";
export const UPDATE_SELL_TRANSACTION = "UPDATE_SELL_TRANSACTION";
export const UPDATE_SELL_TRANSACTION_FINISH = "UPDATE_SELL_TRANSACTION_FINISH";
